import React from 'react'
import { StyleSheet, View } from 'react-native'

import { color, fontFamily } from '../../theme'
import { Text } from '../text/text'

const CheatSheetTerms = [
  {
    term: 'Folding',
    definition:
      'means you give up your cards and put no more chips in, you are out of the hand and saving your chips for future hands.'
  },
  {
    term: 'Checking',
    definition: 'means no bet; you pass the action to the next player.'
  },
  {
    term: 'Betting',
    definition: 'is putting chips in the pot and setting a price for others to stay in the hand.'
  },
  {
    term: 'Calling',
    definition: 'is matching someone else’s bet.'
  },
  {
    term: 'Raising',
    definition: 'is an option if there is already a bet in front of you, and you want to increase the price.'
  }
]

export const CheatSheetTerminology = () => {
  return (
    <View style={{ flex: 1 }}>
      {CheatSheetTerms.map((item) => {
        return (
          <Text key={`terminology-${item.term}`} style={style.definition}>
            <Text style={style.term}>{`\u2022 ${item.term} `}</Text>
            {`${item.definition}`}
          </Text>
        )
      })}
    </View>
  )
}

const style = StyleSheet.create({
  definition: {
    color: `${color.palette.smokyBlack}98`,
    fontSize: 16,
    fontFamily: fontFamily.FeatureDeckRegular,
    paddingTop: 15
  },
  term: {
    color: color.palette.smokyBlack,
    fontFamily: fontFamily.FeatureDeckBold
  }
})
